<template>
  <button
    class="btn btn-sm"
    :class="`btn-outline-${variant}`"
    :title="title"
    @click.stop="$emit('click')"
  >
    <span class="material-symbols-outlined" style="font-size:14px">{{ icon }}</span>
  </button>
</template>

<script>
export default {
  name: 'TableActionBtn',
  emits: ['click'],
  props: {
    icon:    { type: String, required: true },
    title:   { type: String, default: '' },
    variant: { type: String, default: 'secondary' },
  },
}
</script>